import * as React from 'react'
import { Site } from '@envato/foundation-types'

import { IExperimentsConfig } from '../../../config/experiments'
import LoadingCover from '../loadingCover'
import { shouldDisplayLoadingCover } from '../../../common/utils/experiments'

interface IProps {
  experimentsReady: boolean
  experimentsConfig: IExperimentsConfig
  currentSite: Site
}

const ExperimentsLoadingCover: React.SFC<IProps> = ({
  children,
  experimentsConfig,
  experimentsReady,
  currentSite
}) => {
  const isLoadingCover = shouldDisplayLoadingCover({
    experimentsReady,
    experimentsConfig,
    currentSite
  })
  return (
    <React.Fragment>
      {isLoadingCover && <LoadingCover />}
      {children}
    </React.Fragment>
  )
}

export default ExperimentsLoadingCover
